import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/consultancy.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function Consultancy() {
  return (
    <div className="ne-page">
      <SEO
        title="Consultancy"
        description="CIRCODU's influence extends well beyond research. We bring our analytical depth and sector expertise directly to clients both locally and globally through specialized consultancy services that inform strategy, de-risk decisions, and drive meaningful outcomes."
        keywords="consultancy, research, sector expertise, strategy, risk management, meaningful outcomes, CIRCODU, consultancy services Uganda"
        url="/our-services/consultancy"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Consultancy</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Our Services</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Consultancy</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Consultancy</b>
              </h5>
              <p className="texty">
                CIRCODU's influence extends well beyond research. We bring our
                analytical depth and sector expertise directly to clients both
                locally and globally through specialized consultancy services
                that inform strategy, de-risk decisions, and drive meaningful
                outcomes.
              </p>

              {/* Our Consultancy Services */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🌐 Our Consultancy Services</b>
              </h5>
              <p className="texty">
                We work with organizations at every stage of their journey,
                offering tailored support across a range of high-impact areas:
              </p>
              <ul className="texty">
                <li className="mt-2">
                  <b>Market Dynamics Evaluations</b> — Understanding the forces
                  shaping your sector so you can move with clarity and
                  confidence
                </li>
                <li className="mt-2">
                  <b>Feasibility Assessments</b> — Rigorous analysis to
                  determine the viability of projects before resources are
                  committed
                </li>
                <li className="mt-2">
                  <b>Midterm Reviews of Renewable Energy Initiatives</b> —
                  Honest, independent evaluations that keep energy projects on
                  track and on target
                </li>
                <li className="mt-2">
                  <b>Consumer Information Document Testing</b> — Ensuring that
                  the information reaching end users is accurate, accessible,
                  and effective
                </li>
                <li className="mt-2">
                  <b>And more</b> — Our consultancy offering is as broad as the
                  challenges our clients face
                </li>
              </ul>

              <hr />

              {/* Closing statement */}
              <p className="texty">
                <i>
                  Whether you are launching a project, evaluating progress, or
                  navigating complex markets, CIRCODU is the partner that brings
                  both the science and the strategy.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Consultancy;
